<div class="mmb-nav" *ngIf="activeMenuItemTitle$ | async as activeTitle">
  <nav [attr.aria-label]="'MMB.navigation.' + activeTitle | finLocalization">
    <ul class="dn-laptop-down ms-xxlarge-b no-list-style ps-large-bottom">
      <li
        finSideBarNavigationItem
        *ngFor="let item of navigationItems$ | async"
        [link]="item.path"
        [title]="'MMB.navigation.' + item.translationKey | finLocalization"
        [active]="(stage$ | async) === item.targetStage"
        [styleClasses]="'nordic-blue-900-text transparent-border-left'"
      ></li>
      <li
        finSideBarNavigationItem
        *ngIf="enableRefetchOrder"
        [link]="'#'"
        [title]="'Refetch Order' + ((orderLoading$ | async) === true ? ' (loading...)' : '')"
        [active]="false"
        [styleClasses]="'nordic-blue-900-text transparent-border-left'"
        (linkClicked)="refetchOrder($event)"
      ></li>
    </ul>

    <fin-expand
      class="dn-laptop-up relative block fill mr-medium-b"
      [key]="'mmb-side-navigation'"
      [id]="'mmb-side-navigation'"
      [finElemTracker]="'navigation-open: manage-booking'"
      [finElemContext]="TRACKING_CONTEXT"
      [finElemType]="ElementTypes.LINK"
      #naviExpand
    >
      <div class="trigger border-bottom border-top flex flex--center pr-xsmall-y focus-inset fill align-left">
        <div class="flex-1 ps-large-l nordic-blue-900-text transform-none font-body-1 bold-type">
          {{ 'MMB.navigation.' + activeTitle | finLocalization }}
        </div>

        <fcom-icon
          class="flex-1 flex--nogrow rotate icon-small nordic-blue-900-text ms-large-r"
          [class.rotate-active]="naviExpand.isOpen$ | async"
          [name]="SvgLibraryIcon.CHEVRON_DOWN"
        ></fcom-icon>
      </div>
      <div class="content">
        <ul class="no-list-style ps-large grey-50-bg">
          <li
            finSideBarNavigationItem
            *ngFor="let item of navigationItems$ | async"
            [link]="item.path"
            [title]="'MMB.navigation.' + item.translationKey | finLocalization"
            [active]="(stage$ | async) === item.targetStage"
            [styleClasses]="'nordic-blue-900-text'"
            (linkClicked)="toggleDetails(naviExpand)"
            data-testid="expand-navigation-item"
          ></li>
          <li
            finSideBarNavigationItem
            *ngIf="enableRefetchOrder"
            [link]="'#'"
            [title]="'Refetch Order' + ((orderLoading$ | async) === true ? ' (loading...)' : '')"
            [active]="false"
            [styleClasses]="'nordic-blue-900-text transparent-border-left'"
            (linkClicked)="refetchOrder($event)"
          ></li>
        </ul>
      </div>
    </fin-expand>
  </nav>
</div>
